module.exports = __webpack_public_path__ + "media/packs/images/flags/ET-3c7403f117cecde407c4e8b19833c271.svg";